import type {SearchCriteriaRaw} from '../../../types';
import {createCategoryIdRule} from '../categoryIdRule';
import type {CategoryIdRule, TSearchTypeCategoryId} from '../types';

export type RawCategoryIdSearchCriteria =
	SearchCriteriaRaw<TSearchTypeCategoryId>;

export const rawCategoryIdCriteriaToRuleObject = (
	criteria: RawCategoryIdSearchCriteria,
): CategoryIdRule => {
	return createCategoryIdRule({
		id: parseInt(criteria.value1) || 1,
		type: criteria.subtype1,
	});
};

export default rawCategoryIdCriteriaToRuleObject;
